"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrades = exports.useLatestPrice = exports.getLatestPriceOb = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const Interfaces_1 = require("../Interfaces");
const QuotationSocketMgr_1 = require("../QuotationSocketMgr");
const getLatestPriceOb = (params) => {
    const { base, quote, exchange = Interfaces_1.EXCHANGE_PIONEXV2, interval = 0 } = params;
    if (!base || !quote || !exchange) {
        return (0, rxjs_1.throwError)("Invalid params: " + JSON.stringify(params));
    }
    let cacheValue;
    return (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)()
        .getTradesWebSocketV2()
        .getTradesObservable(exchange, base, quote)
        .pipe((0, operators_1.throttleTime)(interval), (0, operators_1.map)((data) => {
        var _a;
        return (_a = data === null || data === void 0 ? void 0 : data[data.length - 1]) === null || _a === void 0 ? void 0 : _a.price;
    }), (0, operators_1.filter)((data) => {
        // 去重
        if (data === cacheValue) {
            return false;
        }
        cacheValue = data;
        return data !== undefined;
    }));
};
exports.getLatestPriceOb = getLatestPriceOb;
/** 获取最新成交中的最新价格 */
const useLatestPrice = (params) => {
    const { base, quote, exchange = Interfaces_1.EXCHANGE_PIONEXV2, interval = 0, isActive = true } = params;
    const [price, setPrice] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!isActive || !base || !quote || !exchange) {
            return;
        }
        const sub = (0, exports.getLatestPriceOb)({ base, quote, exchange, interval }).subscribe({
            next: (data) => {
                setPrice(data);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [base, exchange, interval, isActive, quote]);
    return price;
};
exports.useLatestPrice = useLatestPrice;
const useTrades = (params) => {
    const { base, quote, exchange = Interfaces_1.EXCHANGE_PIONEXV2, isActive = true, maxCount } = params;
    const [trades, setTrades] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (!isActive || !base || !quote || !exchange) {
            return;
        }
        const sub = (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)()
            .getTradesWebSocketV2()
            .getTradesObservable(exchange, base, quote)
            .subscribe({
            next: (data) => {
                if (!data.length) {
                    return;
                }
                let parsedData;
                if (maxCount && data.length > maxCount) {
                    parsedData = data.slice(-maxCount);
                }
                else {
                    parsedData = data.slice();
                }
                parsedData = parsedData.sort((a, b) => b.timestamp - a.timestamp);
                setTrades(parsedData);
            },
            error: () => { },
        });
        return () => {
            setTrades([]);
            sub.unsubscribe();
        };
    }, [base, exchange, isActive, maxCount, quote]);
    return trades;
};
exports.useTrades = useTrades;
